/**
 * Thresholds for displaying toolbox buttons.
 */
export const THRESHOLDS = [
    {
        width: 565,
        order: ['mySettings', 'tileview', 'raisehand', 'desktop', 'participants-pane', 'chat', 'recording', 'settings', 'showHideFT', 'reactions']
    },
    {
        width: 520,
        order: ['mySettings', 'tileview', 'raisehand', 'chat', 'participants-pane', 'showHideFT']
    },
    {
        width: 470,
        order: ['mySettings', 'tileview', 'raisehand', 'chat', 'participants-pane', 'showHideFT']
    },
    {
        width: 420,
        order: ['mySettings', 'tileview', 'raisehand', 'chat', 'participants-pane', 'showHideFT']
    },
    {
        width: 370,
        order: ['mySettings', 'tileview', 'raisehand', 'chat', 'participants-pane', 'showHideFT']
    },
    {
        width: 225,
        order: ['mySettings', 'tileview', 'raisehand', 'chat', 'participants-pane', 'showHideFT']
    },
    {
        width: 200,
        order: ['mySettings', 'tileview', 'raisehand', 'chat', 'participants-pane', 'showHideFT']
    }
];
/**
 * Main toolbar buttons priority used to determine which button should be picked to fill empty spaces for disabled
 * buttons.
 */
export const MAIN_TOOLBAR_BUTTONS_PRIORITY = [
    // 'microphone',
    // 'camera',
    'mySettings',
    'desktop',
    'chat',
    'raisehand',
    'reactions',
    'participants-pane',
    'tileview',
    'invite',
    'toggle-camera',
    'videoquality',
    // 'fullscreen',
    'closedcaptions',
    'recording',
    'livestreaming',
    'linktosalesforce',
    // 'sharedvideo',
    // 'shareaudio',
    'whiteboard',
    'etherpad',
    'select-background',
    'settings',
    'shortcuts',
    'embedmeeting',
    'feedback',
    'download',
    'help',
    'showHideFT',
    'languages',
    'noisesuppression',
    'profile',
    'flipImage',
    'moderator',
    'notifications',
    'stats',
    'security'
];
export const TOOLBAR_TIMEOUT = 4000;
export const DRAWER_MAX_HEIGHT = '80dvh - 64px';
// Around 300 to be displayed above components like chat
export const ZINDEX_DIALOG_PORTAL = 302;
/**
 * Color for spinner displayed in the toolbar.
 */
export const SPINNER_COLOR = '#929292';
/**
 * The list of all possible UI buttons.
 *
 * @protected
 * @type Array<string>
 */
// export const TOOLBAR_BUTTONS: ToolbarButton[] = [
//     'camera',
//     'chat',
//     'closedcaptions',
//     'desktop',
//     'download',
//     'embedmeeting',
//     'etherpad',
//     'feedback',
//     'filmstrip',
//     'fullscreen',
//     'hangup',
//     'help',
//     'highlight',
//     'invite',
//     'linktosalesforce',
//     'livestreaming',
//     'microphone',
//     'mute-everyone',
//     'mute-video-everyone',
//     'participants-pane',
//     'profile',
//     'raisehand',
//     'recording',
//     'security',
//     'select-background',
//     'settings',
//     'shareaudio',
//     'noisesuppression',
//     'sharedvideo',
//     'shortcuts',
//     'stats',
//     'tileview',
//     'toggle-camera',
//     'videoquality',
//     'whiteboard'
// ];
export const TOOLBAR_BUTTONS = [
    'mySettings',
    'camera',
    'chat',
    'desktop',
    // 'fullscreen',
    'hangup',
    'microphone',
    'participants-pane',
    'raisehand',
    'recording',
    'settings',
    // 'shareaudio',
    // 'sharedvideo',
    'tileview',
    'showHideFT',
    'filmstrip'
];
/**
 * The toolbar buttons to show when in visitors mode.
 */
export const VISITORS_MODE_BUTTONS = [
    'chat',
    'closedcaptions',
    'hangup',
    'raisehand',
    'settings',
    'tileview',
    'fullscreen',
    'stats',
    'videoquality'
];
